import { genericMemo } from "@redotech/react-util/component";
import { BooleanEvaluationExpression } from "@redotech/redo-model/advanced-flow/expressions/boolean-expression";
import { Schema } from "@redotech/redo-model/advanced-flow/type-system/schema";
import { TextRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { DeepPartial } from "@redotech/util/type";
import { useEffect } from "react";

const booleanOptions: TextRedoListItem<boolean>[] = [
  { id: "true", type: "text", text: "True", value: true },
  { id: "false", type: "text", text: "False", value: false },
];

export const BooleanInspector = genericMemo(function BooleanInspector({
  schema,
  dataType,
  expression,
  setExpression,
}: {
  schema: Schema;
  dataType: "Boolean";
  expression: DeepPartial<BooleanEvaluationExpression>;
  setExpression: (expression: DeepPartial<BooleanEvaluationExpression>) => void;
}) {
  useEffect(() => {
    if (!expression.type) {
      setExpression({ ...expression, type: "boolean_evaluation" });
    }
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expression]);

  // May seem funny to return nothing. The useEffect above is the main point of this component.
  // But it is conceivable that this component could be expanded in the future, like with an "invert" toggle
  return (
    <RedoSingleSelectDropdownInput<boolean>
      label="Boolean match type"
      options={booleanOptions}
      optionSelected={({ item: value }) => {
        setExpression({ ...expression, value: value.value });
      }}
      selectedItem={booleanOptions.find(
        (option) => option.value === (expression.value ?? true),
      )}
      size="xs"
    />
  );
});
